
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0f0f0f] border-t border-amber-900/20">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/135f79ca-565d-4aa9-b749-0932a8e3ae2e.png"
                alt="Shahbaz Law Firm"
                className="h-10 w-auto"
              />
              <div>
                <div className="text-white font-bold text-lg">Shahbaz Law Firm</div>
                <div className="text-amber-500 text-xs">Legal Excellence</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Trusted legal representation in Karachi since 2008. Expert lawyers providing comprehensive legal services across all practice areas.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-amber-600/10 hover:bg-amber-600/20 rounded-lg text-amber-500 transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-amber-600/10 hover:bg-amber-600/20 rounded-lg text-amber-500 transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-amber-600/10 hover:bg-amber-600/20 rounded-lg text-amber-500 transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-amber-600/10 hover:bg-amber-600/20 rounded-lg text-amber-500 transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Practice Areas', path: '/practice-areas' },
                { name: 'Contact', path: '/contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-amber-500 text-sm transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Practice Areas */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Practice Areas</h3>
            <ul className="space-y-3">
              {[
                'Criminal Law',
                'Civil Suits',
                'Family Law',
                'Estate Administration',
                'Corporate Law',
                'Property Law'
              ].map((area) => (
                <li key={area}>
                  <Link
                    to="/practice-areas"
                    className="text-gray-400 hover:text-amber-500 text-sm transition-colors duration-300 cursor-pointer"
                  >
                    {area}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-amber-500 text-lg mt-0.5"></i>
                <div>
                  <div className="text-gray-400 text-sm">Suite 301, 3rd Floor</div>
                  <div className="text-gray-400 text-sm">Shahrah-e-Faisal, Karachi</div>
                  <div className="text-gray-400 text-sm">Sindh 75400, Pakistan</div>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-amber-500 text-lg"></i>
                <a href="tel:+922112345678" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                  +92 21 1234 5678
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-amber-500 text-lg"></i>
                <a href="mailto:info@shahbazlawfirm.pk" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                  info@shahbazlawfirm.pk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-amber-900/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2024 Shahbaz Law Firm. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
